import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import './style.scss';

const DossiersAllOverview = ({ onLoadMore, pager, loading, entities, setCurrentPage, ...props }) => {

  return (
    <div className="View DossiersAllOverview">
      <div className="row no-gutters">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 DossiersAllOverview__item-wrapper';

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
                isLarge
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DossiersAllOverview;
